module.exports = __webpack_public_path__ + "static/media/branded-order-card-placeholder.ec9c059d.svg";